import { useState } from "react";

export const useIsolatedPages = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState("");
  const [order, setOrder] = useState("");
  const [status, setStatus] = useState("");
  const [filter, setFilter] = useState("all");
  const [type, setType] = useState("");
  const [length, setLength] = useState(10);

  return {
    search,
    setSearch,
    page,
    setPage,
    sort,
    setSort,
    order,
    setOrder,
    status,
    setStatus,
    filter,
    setFilter,
    type,
    setType,
    length,
    setLength,
  };
};
